export default __webpack_public_path__ + "static/media/bloodPressure.5abf9a80.jpg";